// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

/*------------HOW TO INSTALL-------------/*
/*npm install i18next react-i18next*/
/*------------HOW TO INSTALL-------------*/

/*------------HOW TO USE-----------------*/
/* FIRST in App.js */
/*import i18n from './i18n';*/
/*import ReactDOM from 'react-dom';*/
/*import { I18nextProvider } from 'react-i18next';*/
/*import i18n from './Translator/i18nConfiguration';*/
/*ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>,
  document.getElementById('root')
);*/

/* SECOND in Every Page.js */
/*import { useTranslation } from "react-i18next";*/
/*const { t } = useTranslation();*/
/*string myString = t('myString');*/
/*------------HOW TO USE-----------------*/

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        //general
        greeting: "Hello, world!",
        on: "ON",
        off: "OFF",
        yes: "Yes",
        no: "No",

        //languageMenu
        changeLanguage: "Change Language",
        //menu
        configuration: "Configuration",
        menu: "Menu",
        settings: "Settings",
        userSettings: "User Settings",
        profileSettings: "Profile Settings",
        logout: "Logout",
        language: "Language",

        //mainPage
        mainTitle: "Dashboard",

        //loginPage
        loginTitle: "Login",
        username: "Username",
        password: "Password",
        login: "Login",
        passwordForgotten: "Forgotten password?",

        loginMessage1: "Wrong username or password",

        //topbar
        alarms: "Alarms",
        continousData: "Continuous Data",
        events: "Events",

        //search
        searchPanelTitle: "Search Panel",
        noData: "No Data",
        processing: "Number of processing data points: ",
        measuresDetails: "Details & Settings",
        startDate: "Start Date",
        endDate: "End Date",
        from: "From",
        to: "To",
        all: "All",
        machine: "Machine",
        specificMachine: "Specific Machine",
        specific: "Specific",
        search: "Search",
        measures: "Select Measures",
        searchPlaceholder: "Search for an alarm",
        measuresPlaceholder: "Select Measures",
        eventPlaceholder: "Select Event",
        topPlaceholder: "All Records",
        idPlaceholder: "All Ids",
        maxRecords: "Max Records per Machine",
        sampleTime: "Sample Time",
        machinePlaceholder: "Select a machine",
        showGraph: "Show Graph",
        showTable: "Show Table",
        timestamp: "Timestamp",
        description: "Description",
        id: "ID",
        status: "Status",
        idValue: "ID",
        event: "Event",
        export: "Export",
        filters: "Filters",
        sampleTimePlaceholder: "Max Sample Rate",
        eventname: "Event Name",
        onlyActive: "Only Active Alarms",
        eventName: "Event Name",
        measurename: "Measure Name",
        running: "Running Data",
        saveProfile: "Save Profile",
        loadProfile: "Load Profile",
        deleteProfile: "Delete Profile",
        selectProfile: "Select Profile",
        load: "Load",
        save: "Save",
        delete: "Delete",
        profileName: "Profile Name",
        profileNamePlaceholder: "Enter Profile Name",
        profileDetails: "Profile Details",
        endProcess: "End Process",
        curves: "Curves",
        unit: "Mes. Unit",
        openCurves: "Open Curves",
        image: "Show Piece",
        measure: "Measure",
        graphtype: "Graph Type",
        avg: "Avg",
        stddev: "Std. Dev.",
        range: "Range",
        lcl: "LCL",
        ucl: "UCL",
        spcheader: "Statistical Process Control (SPC) Summary",
        spc: "SPC Info",
        realtime: "Realtime",
        statistics: "Statistics",
        distributions: "Distribution",
        frequency: "Frequency",
        trends: "Trends",

        //errors
        error: "Error",
        error0: "Something went wrong",
        error1: "Start Date is greater than End Date",
        error2: "Error while fetching data",
        error3: "Select event first",

        //warning
        warning: "Warning",
        warning0: "Generic Warning",
        warning1: "No data found",

        //success
        success: "Success",
        success0: "Data fetched successfully",
        success1: "Data sent successfully",

        //dbservicerrors
        dberror: "Error",
        dberror0: "Something went wrong",
        dberror1: "Transfer Failed",
        dberror2: "Trasfer Cancelled",
        dberror3: "Request Timeout",

        //measuresMetadataDialog
        name: "Name",
        type: "Type",
        measuringUnit: "Measuring Unit",
        min: "Min",
        max: "Max",
        color: "Color",

        // ... other English translations
      },
    },
    de: {
      translation: {
        //general
        greeting: "Hallo, Welt!",
        on: "AN",
        off: "AUS",
        yes: "Ja",
        no: "Nein",

        //languageMenu
        changeLanguage: "Sprache ändern",

        //menu
        configuration: "Konfiguration",
        menu: "Menü",
        settings: "Einstellungen",
        userSettings: "Benutzereinstellungen",
        profileSettings: "Profileinstellungen",
        logout: "Abmelden",
        language: "Sprache",

        //mainPage
        mainTitle: "Dashboard",

        //loginPage
        loginTitle: "Anmeldung",
        username: "Benutzername",
        password: "Passwort",
        login: "Anmelden",
        passwordForgotten: "Passwort vergessen?",

        loginMessage1: "Falscher Benutzername oder Passwort",

        //topbar
        alarms: "Alarme",
        continousData: "Kontinuierliche Daten",
        events: "Ereignisse",

        //search
        searchPanelTitle: "Suchbereich",
        noData: "Keine Daten",
        processing: "Anzahl der verarbeiteten Datenpunkte: ",
        measuresDetails: "Details & Einstellungen",
        startDate: "Startdatum",
        endDate: "Enddatum",
        from: "Von",
        to: "Bis",
        all: "Alle",
        machine: "Maschine",
        specificMachine: "Spezifische Maschine",
        specific: "Spezifisch",
        search: "Suchen",
        measures: "Messwerte auswählen",
        searchPlaceholder: "Nach einem Alarm suchen",
        measuresPlaceholder: "Messwerte auswählen",
        eventPlaceholder: "Ereignis auswählen",
        topPlaceholder: "Alle Einträge",
        idPlaceholder: "Alle IDs",
        maxRecords: "Maximale Einträge pro Maschine",
        sampleTime: "Abtastzeit",
        machinePlaceholder: "Maschine auswählen",
        showGraph: "Diagramm anzeigen",
        showTable: "Tabelle anzeigen",
        timestamp: "Zeitstempel",
        description: "Beschreibung",
        id: "ID",
        status: "Status",
        idValue: "Blade-ID",
        event: "Ereignis",
        export: "Exportieren",
        filters: "Filter",
        sampleTimePlaceholder: "Maximale Abtastrate",
        eventname: "Ereignisname",
        onlyActive: "Nur aktive Alarme",
        eventName: "Ereignisname",
        measurename: "Messname",
        running: "Laufende Daten",
        saveProfile: "Profil speichern",
        loadProfile: "Profil laden",
        deleteProfile: "Profil löschen",
        selectProfile: "Profil auswählen",
        load: "Laden",
        save: "Speichern",
        delete: "Löschen",
        profileName: "Profilname",
        profileNamePlaceholder: "Profilnamen eingeben",
        profileDetails: "Profil Details",
        endProcess: "Prozess beenden",
        curves: "Kurven",
        unit: "Maßeinheit",
        openCurves: "Kurven öffnen",
        image: "Stück anzeigen",
        measure: "Messwert",
        graphtype: "Diagrammtyp",
        avg: "Durchschnitt",
        stddev: "Standardabweichung",
        range: "Bereich",
        lcl: "LCL",
        ucl: "UCL",
        spcheader: "Statistische Prozesskontrolle (SPC) Zusammenfassung",
        spc: "SPC Info",
        realtime: "Echtzeit",
        statistics: "Statistiken",
        distributions: "Verteilung",
        frequency: "Frequenz",
        trends: "Trends",

        //errors
        error: "Fehler",
        error0: "Etwas ist schiefgelaufen",
        error1: "Das Startdatum ist größer als das Enddatum",
        error2: "Fehler beim Abrufen der Daten",
        error3: "Zuerst ein Ereignis auswählen",

        //warning
        warning: "Warnung",
        warning0: "Allgemeine Warnung",
        warning1: "Keine Daten gefunden",

        //success
        success: "Erfolg",
        success0: "Daten erfolgreich abgerufen",
        success1: "Daten erfolgreich gesendet",

        //dbservicerrors
        dberror: "Fehler",
        dberror0: "Etwas ist schiefgelaufen",
        dberror1: "Übertragung fehlgeschlagen",
        dberror2: "Übertragung abgebrochen",
        dberror3: "Zeitüberschreitung der Anfrage",

        //measuresMetadataDialog
        name: "Name",
        type: "Typ",
        measuringUnit: "Maßeinheit",
        min: "Min",
        max: "Max",
        color: "Farbe",

        // ... weitere deutsche Übersetzungen
      },
    },

    it: {
      translation: {
        //general
        greeting: "Ciao, mondo!",
        on: "ON",
        off: "OFF",
        yes: "Sì",
        no: "No",

        //languageMenu
        changeLanguage: "Cambia lingua",

        //menu
        configuration: "Configurazione",
        menu: "Menu",
        settings: "Impostazioni",
        userSettings: "Impostazioni utente",
        profileSettings: "Impostazioni profilo",
        logout: "Esci",
        language: "Lingua",

        //mainPage
        mainTitle: "Dashboard",

        //loginPage
        loginTitle: "Accesso",
        username: "Nome utente",
        password: "Password",
        login: "Accedi",
        passwordForgotten: "Password dimenticata?",

        loginMessage1: "Nome utente o password errati",

        //topbar
        alarms: "Allarmi",
        continousData: "Dati continui",
        events: "Eventi",

        //search
        searchPanelTitle: "Pannello di ricerca",
        noData: "Nessun dato",
        processing: "Numero di punti dati in elaborazione: ",
        measuresDetails: "Dettagli e impostazioni",
        startDate: "Data di inizio",
        endDate: "Data di fine",
        from: "Da",
        to: "A",
        all: "Tutti",
        machine: "Macchina",
        specificMachine: "Macchina specifica",
        specific: "Specifica",
        search: "Cerca",
        measures: "Seleziona misure",
        searchPlaceholder: "Cerca un allarme",
        measuresPlaceholder: "Seleziona misure",
        eventPlaceholder: "Seleziona evento",
        topPlaceholder: "Tutti i record",
        idPlaceholder: "Tutti gli ID",
        maxRecords: "Record massimi per macchina",
        sampleTime: "Tempo di campionamento",
        machinePlaceholder: "Seleziona una macchina",
        showGraph: "Mostra grafico",
        showTable: "Mostra tabella",
        timestamp: "Timestamp",
        description: "Descrizione",
        id: "ID",
        status: "Stato",
        idValue: "ID lama",
        event: "Evento",
        export: "Esporta",
        filters: "Filtri",
        sampleTimePlaceholder: "Frequenza di campionamento massima",
        eventname: "Nome evento",
        onlyActive: "Solo allarmi attivi",
        eventName: "Nome evento",
        measurename: "Nome misura",
        running: "Dati in esecuzione",
        saveProfile: "Salva profilo",
        loadProfile: "Carica profilo",
        deleteProfile: "Elimina profilo",
        selectProfile: "Seleziona profilo",
        load: "Carica",
        save: "Salva",
        delete: "Elimina",
        profileName: "Nome profilo",
        profileNamePlaceholder: "Inserisci nome profilo",
        profileDetails: "Dettagli del profilo",
        endProcess: "Fine processo",
        curves: "Curve",
        unit: "Unità di misura",
        openCurves: "Apri curve",
        image: "Mostra Pezzo",
        measure: "Misura",
        graphtype: "Tipo di grafico",
        avg: "Media",
        stddev: "Deviazione standard",
        range: "Range",
        lcl: "LCL",
        ucl: "UCL",
        spcheader: "Riepilogo di controllo del processo statistico (SPC)",
        spc: "SPC Info",
        realtime: "Tempo Reale",
        statistics: "Statistiche",
        distributions: "Distribuzione",
        frequency: "Frequenza",
        trends: "Trends",

        //errors
        error: "Errore",
        error0: "Qualcosa è andato storto",
        error1: "La data di inizio è maggiore della data di fine",
        error2: "Errore nel recupero dei dati",
        error3: "Seleziona prima un evento",

        //warning
        warning: "Avviso",
        warning0: "Avviso generico",
        warning1: "Nessun dato trovato",

        //success
        success: "Successo",
        success0: "Dati recuperati con successo",
        success1: "Dati inviati con successo",

        //dbservicerrors
        dberror: "Errore",
        dberror0: "Qualcosa è andato storto",
        dberror1: "Trasferimento fallito",
        dberror2: "Trasferimento annullato",
        dberror3: "Timeout della richiesta",

        //measuresMetadataDialog
        name: "Nome",
        type: "Tipo",
        measuringUnit: "Unità di misura",
        min: "Min",
        max: "Max",
        color: "Colore",

        // ... altre traduzioni italiane
      },
    },

    fr: {
      translation: {
        //general
        greeting: "Bonjour, le monde !",
        on: "ACTIF",
        off: "INACTIF",
        yes: "Oui",
        no: "Non",

        //languageMenu
        changeLanguage: "Changer de langue",

        //menu
        configuration: "Configuration",
        menu: "Menu",
        settings: "Paramètres",
        userSettings: "Paramètres utilisateur",
        profileSettings: "Paramètres du profil",
        logout: "Déconnexion",
        language: "Langue",

        //mainPage
        mainTitle: "Tableau de bord",

        //loginPage
        loginTitle: "Connexion",
        username: "Nom d'utilisateur",
        password: "Mot de passe",
        login: "Se connecter",
        passwordForgotten: "Mot de passe oublié ?",
        loginMessage1: "Nom d'utilisateur ou mot de passe incorrect",

        //topbar
        alarms: "Alarmes",
        continousData: "Données continues",
        events: "Événements",

        //search
        searchPanelTitle: "Panneau de recherche",
        noData: "Aucune donnée",
        processing: "Nombre de points de données en cours de traitement : ",
        measuresDetails: "Détails et paramètres",
        startDate: "Date de début",
        endDate: "Date de fin",
        from: "De",
        to: "À",
        all: "Tous",
        machine: "Machine",
        specificMachine: "Machine spécifique",
        specific: "Spécifique",
        search: "Rechercher",
        measures: "Sélectionner les mesures",
        searchPlaceholder: "Rechercher une alarme",
        measuresPlaceholder: "Sélectionner des mesures",
        eventPlaceholder: "Sélectionner un événement",
        topPlaceholder: "Tous les enregistrements",
        idPlaceholder: "Tous les identifiants",
        maxRecords: "Nombre max. d’enregistrements par machine",
        sampleTime: "Temps d’échantillonnage",
        machinePlaceholder: "Sélectionner une machine",
        showGraph: "Afficher le graphique",
        showTable: "Afficher le tableau",
        timestamp: "Horodatage",
        description: "Description",
        id: "ID",
        status: "Statut",
        idValue: "ID",
        event: "Événement",
        export: "Exporter",
        filters: "Filtres",
        sampleTimePlaceholder: "Taux d’échantillonnage max",
        eventname: "Nom de l’événement",
        onlyActive: "Alarmes actives uniquement",
        eventName: "Nom de l’événement",
        measurename: "Nom de la mesure",
        running: "Données en cours",
        saveProfile: "Enregistrer le profil",
        loadProfile: "Charger le profil",
        deleteProfile: "Supprimer le profil",
        selectProfile: "Sélectionner un profil",
        load: "Charger",
        save: "Enregistrer",
        delete: "Supprimer",
        profileName: "Nom du profil",
        profileNamePlaceholder: "Entrer le nom du profil",
        profileDetails: "Détails du profil",
        endProcess: "Terminer le processus",
        curves: "Courbes",
        unit: "Unité de mesure",
        openCurves: "Ouvrir les courbes",
        image: "Afficher la pièce",
        measure: "Mesure",
        graphtype: "Type de graphique",
        avg: "Moyenne",
        stddev: "Écart-type",
        range: "Plage",
        lcl: "LCL",
        ucl: "UCL",
        spcheader: "Résumé du Contrôle Statistique du Processus (SPC)",
        spc: "Informations SPC",
        realtime: "Temps Réel",
        statistics: "Statistiques",
        distributions: "Distribution",
        frequency: "Fréquence",
        trends: "Tendances",

        //errors
        error: "Erreur",
        error0: "Une erreur est survenue",
        error1: "La date de début est postérieure à la date de fin",
        error2: "Erreur lors de la récupération des données",
        error3: "Sélectionnez d’abord un événement",

        //warning
        warning: "Avertissement",
        warning0: "Avertissement générique",
        warning1: "Aucune donnée trouvée",

        //success
        success: "Succès",
        success0: "Données récupérées avec succès",
        success1: "Données envoyées avec succès",

        //dbservicerrors
        dberror: "Erreur",
        dberror0: "Une erreur est survenue",
        dberror1: "Transfert échoué",
        dberror2: "Transfert annulé",
        dberror3: "Délai d’attente dépassé",

        //measuresMetadataDialog
        name: "Nom",
        type: "Type",
        measuringUnit: "Unité de mesure",
        min: "Min",
        max: "Max",
        color: "Couleur",
      },
    },

    dk: {
      translation: {
        //general
        greeting: "Hej Verden",
        on: "AN",
        off: "AUS",
        yes: "Ja",
        no: "Nej",
        //languageMenu
        changeLanguage: "Skift Sprog",
        //menu
        configuration: "Konfiguration",
        menu: "Menu",
        settings: "Indstillinger",
        userSettings: "Brugerindstillinger",
        profileSettings: "Profilindstillinger",
        logout: "Log ud",
        language: "Sprog",

        //mainPage
        mainTitle: "Dashboard",

        //loginPage
        loginTitle: "Login",
        username: "Username",
        password: "Password",
        login: "Login",
        passwordForgotten: "Glemt adgangskode?",
        loginMessage1: "Forkert brugernavn eller adgangskode",
        //topbar
        alarms: "Alarmer",
        continousData: "Kontinuært Data",
        events: "Hændelser",
        //search
        searchPanelTitle: "Søgepanel",
        noData: "Ingen Data",
        processing: "Antal behandlede datapunkter: ",
        measuresDetails: "Detaljer & Indstillinger",
        startDate: "Startdato",
        endDate: "Slutdato",
        from: "Fra",
        to: "Til",
        all: "Alle",
        machine: "Maskine",
        specificMachine: "Specifik Maskine",
        specific: "Specifik",
        search: "Søg",
        measures: "Vælg Målinger",
        searchPlaceholder: "Søg efter alarm",
        measuresPlaceholder: "Vælg Målinger",
        eventPlaceholder: "Vælg Hændelse",
        topPlaceholder: "Alle Poster",
        idPlaceholder: "Alle Ids",
        maxRecords: "Max Poster pr. Maskine",
        sampleTime: "Sample Time",
        machinePlaceholder: "Vælg en maskine",
        showGraph: "Vis Graf",
        showTable: "Vis Tabel",
        timestamp: "Timestamp",
        description: "Beskrivelse",
        id: "ID",
        status: "Status",
        idValue: "ID",
        event: "Hændelse",
        export: "Eksportér",
        filters: "Filtre",
        sampleTimePlaceholder: "Max Sample Rate",
        eventname: "Event Navn",
        onlyActive: "Kun Aktive Alarmer",
        eventName: "Hændelsesnavn",
        measurename: "Målenavn",
        running: "Løbende Data",
        saveProfile: "Gem Profil",
        loadProfile: "Indlæs Profil",
        deleteProfile: "Slet Profil",
        selectProfile: "Vælg Profil",
        load: "Indlæs",
        save: "Gem",
        delete: "Slet",
        profileName: "Profilnavn",
        profileNamePlaceholder: "Indtast Profilnavn",
        profileDetails: "Profil Detaljer",
        endProcess: "Afslut Proces",
        curves: "Kurver",
        unit: "Måleenhed",
        openCurves: "Åbn Kurver",
        image: "Vis Komponent",
        measure: "Måling",
        graphtype: "Graf Type",
        avg: "Gennemsnit",
        stddev: "Standard Deviation",
        range: "Range",
        lcl: "LCL",
        ucl: "UCL",
        spcheader: "SPC Kontrol",
        spc: "SPC Info",
        statistics: "Statistikker",
        distributions: "Fordeling",
        frequency: "Frekvens",
        trends: "Trends",

        //errors
        error: "Fejl",
        error0: "Noget gik galt",
        error1: "Startdatoen er større end slutdatoen",
        error2: "Fejl ved hentning af data",
        error3: "Vælg hændelse først",

        //warning
        warning: "Advarsel",
        warning0: "Generelt Advarsel",
        warning1: "Ingen data fundet",

        //success
        success: "Succes",
        success0: "Data hentet med succes",
        success1: "Data sendt med succes",

        //dbservicerrors
        dberror: "Fejl",
        dberror0: "Noget gik galt",
        dberror1: "Overførsel mislykkedes",
        dberror2: "Overførsel annulleret",
        dberror3: "Anmodning Timeout",
        //measuresMetadataDialog
        name: "Navn",
        type: "Type",
        measuringUnit: "Måleenhed",
        min: "Min",
        max: "Max",
        color: "Farve",

        // ... other Danish translations
      },
    },
    // ... other languages
  },
  lng: "en", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already safe from xss
  },
});

export default i18n;
